import * as React from "react";

function SvgCompany(props) {
  return <svg width={16} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.333 5.167H2.667c-.737 0-1.334.597-1.334 1.333v6.667c0 .736.597 1.333 1.334 1.333h10.666c.737 0 1.334-.597 1.334-1.333V6.5c0-.736-.597-1.333-1.334-1.333z" stroke="#A0ABC0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M10.667 14.5V3.833A1.334 1.334 0 009.333 2.5H6.667a1.333 1.333 0 00-1.334 1.333V14.5" stroke="#A0ABC0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

export default SvgCompany;